import { render, staticRenderFns } from "./PendingOrder.vue?vue&type=template&id=adda58aa&scoped=true"
import script from "./PendingOrder.vue?vue&type=script&lang=js"
export * from "./PendingOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adda58aa",
  null
  
)

export default component.exports